import { makeService } from './api';

const service = makeService('mail_attachments');

export default service;